import { render, staticRenderFns } from "./Finalizados.vue?vue&type=template&id=01014ae0"
import script from "./Finalizados.vue?vue&type=script&lang=js"
export * from "./Finalizados.vue?vue&type=script&lang=js"
import style0 from "./Finalizados.vue?vue&type=style&index=0&id=01014ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports